import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
// import {LogsService} from '@gtpl/shared-services/user-logs';
import { CertificatesController } from './certificates.controller';
import { Certificates } from './certificates.entity';
import { CertificatesService } from './certificates.service';
import { CertificatesAdapter } from './dto/certificates.adapter';

@Module({
  imports: [
    TypeOrmModule.forFeature([Certificates]),
 // forwardRef(() => ClusterModule),
],
  controllers: [CertificatesController],
  providers: [CertificatesService,CertificatesAdapter,ApplicationExceptionHandler,LogsService],
  exports: [CertificatesService],
})
export class CertificatesModule {}
